import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaEye, FaEyeSlash, FaExclamationCircle } from 'react-icons/fa';
import './Form.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login({ username, password });
        } catch (err) {
            setError(err.response?.data?.message || 'Login gagal. Periksa kembali data Anda.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit} className="auth-form">
                <h2>Login</h2>
                {/* Teks subtitle dipindahkan dari sini */}

                {error && (
                    <div className="error-message-general">
                        <FaExclamationCircle />
                        <span>{error}</span>
                    </div>
                )}

                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required className={error ? 'input-error' : ''} />
                </div>

                <div className="form-group password-group">
                    <label htmlFor="password">Password</label>
                    <div className="password-input-wrapper">
                        <input type={showPassword ? 'text' : 'password'} id="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={error ? 'input-error' : ''} />
                        <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                    </div>
                </div>

                <button type="submit" className="submit-button" disabled={isLoading}>
                    {isLoading ? 'Memuat...' : 'Login'}
                </button>

                {/* --- DAN DIPINDAHKAN KE SINI --- */}
                <p className="form-footer-link">
                    Belum punya akun? <Link to="/register">Daftar di sini</Link>
                </p>
            </form>
        </div>
    );
};

export default LoginPage;